/* eslint-disable max-len */
import { getListPlaylist,
  getStatusPublicPlaylist,
  setStatusPublicPlaylist,
  setStatusPlaylist,
  reOrderPlaylist,
  createPlaylist,
  updatePlaylist,
  deletePlaylist,
  getGenreSong,
  getListSong,
  getDetailPlaylist,
} from '@/services/playlist';

const getters = {
  listPlaylist: state => state.listPlaylist,
  listSongSearch: state => state.listSongSearch,
  listGenreSong: state => state.listGenreSong,
};

const actions = {
  async requestGetListPlaylist({ commit, dispatch, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const result = await getListPlaylist({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_PLAYLIST', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetStatusPublicPlaylist({ commit, dispatch, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const result = await getStatusPublicPlaylist({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = result.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestSetStatusPublicPlaylist({ commit, dispatch, rootGetters }, status) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setStatusPublicPlaylist(status, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSetStatusPlaylist({ commit, dispatch, rootGetters }, status) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setStatusPlaylist(status, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestGetListPlaylist');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestReOrderPlaylist({ commit, dispatch, rootGetters }, playlist) {
    // commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await reOrderPlaylist(playlist, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      // commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreatePlaylist({ commit, dispatch, rootGetters }, playlist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createPlaylist(playlist, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-create-playlist' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdatePlaylist({ commit, dispatch, rootGetters }, playlist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await updatePlaylist(playlist, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-update-playlist' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeletePlaylist({ commit, dispatch, rootGetters }, playlist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deletePlaylist(playlist, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestGetListPlaylist');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-delete-playlist' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetGenreSong({ commit, dispatch, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = [];
    try {
      const res = await getGenreSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = res.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-delete-playlist' }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestGetListSong({ commit, dispatch, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const result = await getListSong(filter, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_LIST_SONG_SEARCH', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailPlaylist({ commit, dispatch, rootGetters }, id) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      const result = await getDetailPlaylist(id, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = result.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
};

const mutations = {
  SET_LIST_PLAYLIST(state, listPlaylist) {
    state.listPlaylist = listPlaylist;
  },
  SET_LIST_SONG_SEARCH(state, listSongSearch) {
    state.listSongSearch = listSongSearch;
  },
  SET_LIST_GENRE_SONG(state, listGenre) {
    state.listGenreSong = listGenre;
  },
};

export default {
  namespaced: true,
  state: {
    listPlaylist: [],
    listSongSearch: [],
    listGenreSong: [],
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Playlist/index.js